<template>
    <div class="datepicker-trigger">
        <div class="input-group">
            <div v-if="prependText!=null" class="input-group-prepend">
                <span class="input-group-text" id="basic-addon2">{{ prependText }}</span>
            </div>
            <input
            type="text" class="form-control"
            :id="'datepicker-trigger'+name"
            :value="dateOne"
            :name="name"
            :required="required"
            :autofocus="autofocus"
            v-bind:class="{'is-invalid':invalid}"
            >
            <div v-if="appendText!=null" class="input-group-append">
                <span class="input-group-text" id="basic-addon2">{{ appendText }}</span>
            </div>
        </div>

      <AirbnbStyleDatepicker
        :trigger-element-id="'datepicker-trigger'+name"
        :mode="'single'"
        :fullscreen-mobile="true"
        :monthsToShow="1"
        :showShortcutsMenuTrigger="false"
        :date-one="dateOne"
        :date-two="dateTwo"
        @date-one-selected="val => { update(val) }"
        @date-two-selected="val => { dateTwo = val }"
      />
    </div>
</template>

<script>
import format from 'date-fns/format'

export default {
    props: [ 
        'value', 
        'name',
        'appendText',
        'prependText',
        'required',
        'autofocus',
        'isInvalid',
    ],
    data() {
        return {
            dateFormat: 'YYYY-MM-DD',
            dateOne: '',
            dateTwo: '',
            invalid: false,
        }
    },
    methods: {
        formatDates(dateOne, dateTwo) {
            let formattedDates = ''
            if (dateOne) {
                formattedDates = format(dateOne, this.dateFormat)
            }
            if (dateTwo) {
                formattedDates += ' - ' + format(dateTwo, this.dateFormat)
            }
            return formattedDates
        },
        update(val) {
            if(format(val,this.dateFormat) != 'Invalid Date') {
                this.invalid = false
                this.dateOne = val
            }
            this.$emit('input', this.formatDates(this.dateOne, this.dateTwo))
        }
    },
    mounted() {
        if(format(this.value, this.dateFormat) == 'Invalid Date') {
            this.dateOne = ''
        } else {
            this.dateOne = this.value
        }
        this.formatDates(this.dateOne, this.dateTwo)
        this.invalid = this.isInvalid
    }
}
</script>